// @greenlight-spec: 28-it-dashboard-ui.md#internal-health--internal-health-org-admin
import * as React from 'react';

import type { HealthSeriesServiceKey } from '@greenlight/shared';

import { Disclosure } from '@/components/greenlight/Disclosure';

import { HistoryProvider, useStoredRange } from './HistoryContext';
import { HistoryPanelHeader } from './HistoryPanelHeader';

/**
 * A card's own history, collapsed under its current readings, with its own
 * range beside its charts. Nothing in it mounts or fetches until it is opened.
 */
export function CardHistory({
  testId,
  label = 'History',
  service,
  className = 'mt-4',
  children,
}: {
  testId: string;
  label?: string;
  /** Narrows every chart and incident marker in the panel to one service. */
  service?: HealthSeriesServiceKey;
  className?: string;
  children: React.ReactNode;
}): React.ReactElement {
  const [range, setRange] = useStoredRange(testId);
  return (
    <Disclosure lazy label={label} hint={`last ${range}`} className={className} testId={testId}>
      <HistoryProvider range={range} setRange={setRange} {...(service ? { service } : {})}>
        <HistoryPanelHeader />
        <div className="grid gap-3 [grid-template-columns:repeat(auto-fill,minmax(min(100%,18rem),1fr))]">
          {children}
        </div>
      </HistoryProvider>
    </Disclosure>
  );
}
